import { render } from "./UserRevision.vue?vue&type=template&id=50071eb1"
import script from "./UserRevision.vue?vue&type=script&lang=js"
export * from "./UserRevision.vue?vue&type=script&lang=js"

import "./UserRevision.vue?vue&type=style&index=0&id=50071eb1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__